import { FormControl, TextField } from '@mui/material';
//constants
import { Ifield } from '../types';
import { getErrorText } from '..';
import { CustomTextField } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
	valid: boolean;
	cField: Ifield;
	initialValidation: any;
	handleChange: any;
};

export default function InputText(props: props) {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation } = props;
	const { name, value, helperText, regex } = cField.props;

	const handleInputChange = (event: any) => {
		const newValue = event.target.value;
		if (regex) {
			regex.test(newValue) && handleChange(event);
		} else handleChange(event);
	};

	return (
		<CustomTextField key={name}>
			<FormControl error={!valid} fullWidth sx={cField.styleObj}>
				<TextField
					error={!valid}
					{...cField.props}
					helperText={valid ? helperText : t(getErrorText(initialValidation, name))}
					value={['null', 'undefined'].includes(typeof value) ? '' : value}
					onChange={handleInputChange}
					variant="filled"
					autoComplete="off"
				/>
			</FormControl>
		</CustomTextField>
	);
}
